import { GoalsOverview } from "../../../common/components/goals/GoalsOverview/GoalsOverview";
import { IGoalsDataSource } from "../../../common/components/goals/models/goalModels";
import { endpointsMetadata } from "../../../common/infrastructure/routes/endpointsMetadata";

const DATA_SOURCE: IGoalsDataSource = {
  listEndpoint: endpointsMetadata.goal.getMyGoals,
  listQueryKey: [endpointsMetadata.goal.getMyGoals],
  setCompletedEndpoint: endpointsMetadata.goal.setMyGoalCompleted,
};

const INTRO = {
  storageKey: "myGoalsIntro",
  title: "Какво са „Моите цели“?",
  text: "Тук виждате целите, които с вашия треньор сте поставили за вас. Успехът идва с постоянството!",
};

/**
 * Portal page with the user's goals. Rendering lives in the reusable GoalsOverview; this
 * page feeds it the caller-scoped endpoints. The client can only check goals off - the
 * trainer sets and edits them on the client's profile.
 */
export const MyGoals = () => {
  return <GoalsOverview dataSource={DATA_SOURCE} intro={INTRO} />;
};
